import React from 'react';
import PropTypes from 'prop-types';
import { fmtDate } from 'helpers/utils';

const DateFormatRenderer = ({ value }) => <>{fmtDate(value)}</>;

DateFormatRenderer.propTypes = { value: PropTypes.string };

export default DateFormatRenderer;
